import { Component } from '@verndale/core';
import Cookies from 'js-cookie';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      parentNode: this.el.parentNode,
      agreeBtn: this.el.querySelector('.cookie-warning__agree'),
      declineBtn: this.el.querySelector('.cookie-warning__decline'),
      dismissBtn: this.el.querySelector('.cookie-warning__dismiss'),
      showBtns: [...document.querySelectorAll('[data-display-cookie-warning]')]
    };

    this.cookieExpiry = 36500;
    this.cookieName = this.el.dataset.cookieName;
    this.cookieValue = Cookies.get(this.cookieName);

    if (this.cookieValue) {
      this.dom.parentNode.removeChild(this.el);
    } else {
      this.el.classList.add('cookie-warning--displayed');
    }
  }

  addListeners() {
    this.dom.agreeBtn.addEventListener('click', () => this.handleAnswer(true));
    this.dom.declineBtn.addEventListener('click', () =>
      this.handleAnswer(false)
    );
    this.dom.dismissBtn.addEventListener(
      'click',
      this.handleDismiss.bind(this)
    );

    this.dom.showBtns.forEach(showBtn =>
      showBtn.addEventListener('click', this.handleShow.bind(this))
    );
  }

  handleAnswer(answer) {
    Cookies.set(this.cookieName, answer, { expires: this.cookieExpiry });
    this.el.classList.remove('cookie-warning--displayed');
  }

  handleDismiss() {
    if (typeof this.cookieValue === 'undefined') {
      Cookies.set(this.cookieName, 'initial', { expires: this.cookieExpiry });
    }

    this.el.classList.remove('cookie-warning--displayed');
    setTimeout(() => this.dom.parentNode.removeChild(this.el), 500);
  }

  handleShow() {
    this.dom.parentNode.appendChild(this.el);
    this.cookieValue = Cookies.get(this.cookieName);

    if (this.cookieValue !== 'initial') {
      this.el.classList.add(
        `cookie-warning--${this.cookieValue === 'true' ? 'agreed' : 'declined'}`
      );
      this.el.classList.remove(
        `cookie-warning--${this.cookieValue === 'true' ? 'declined' : 'agreed'}`
      );
    }
    this.el.focus();
    setTimeout(() => this.el.classList.add('cookie-warning--displayed'), 0);
  }
}

export default Module;
